export const SET_CONTENT = 'SET_CONTENT';
export const  SET_DISCOUNTCONTENT = 'SET_DISCOUNTCONTENT';
export const  SET_DISCOUNTTILECONTENT = 'SET_DISCOUNTTILECONTENT'
